import '@/scss/pages/math-tax.scss'

import header from '../layout/header'
import fullForm from '../section/home/full-form'
import singleCTA from '../section/blog/single-cta'
import mathMenu from '../section/math/menu'
import initExitPopup from '../section/exit-popup'
import initStrip from '../section/blog/strip'
import {
  setTrackExitPopupCloseEvent,
  setTrackStripCloseEvent
} from '../common/button-track'

document.addEventListener('DOMContentLoaded', function () {
  header()
  mathMenu()
  singleCTA()
  fullForm()
  initExitPopup()
  initStrip()
  setTrackStripCloseEvent()
  setTrackExitPopupCloseEvent()
})
